// Подсказки в поле «Значение» у опции комплектации — свои у каждой секции,
// чтобы было понятно, что писать: «Датчики парковки» — «Задние».
export const SAFETY_VALUE_PLACEHOLDER = 'Значение, например «Задние»';
export const EQUIPMENT_VALUE_PLACEHOLDER = 'Значение, например «10,25", Apple CarPlay»';
